<template>
	<div class="accounting-searcher">
		<v-layout wrap>
			<v-flex xs12>
				<v-layout wrap align-end>
					<v-flex xs7 pr-3>
						<input-searcher
							:height="32"
							readonly
							:value="accountName"
							@click="$emit('open-searcher')"
							@open-searcher="$emit('open-searcher')"
						/>
					</v-flex>
					<v-flex xs5>
						<BaseInput
							:height="32"
							v-model="account"
							label="Cuenta Contable"
							hide-details
							readonly
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import inputSearcher from '@/components/shared/searcher/input-searcher';

	export default {
		name: 'accounting-searcher',
		components: {
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			inputSearcher,
		},
		props: {
			account: [Number, String],
			accountName: String,
			placeHolder: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/shared/searcher/accounting-searcher.vue